module.exports = __webpack_public_path__ + "img/logo19.ab4bd0bd.png";